import './template_press_single.css'
